import React, { useRef } from 'react';
import Slider from 'react-slick';
import styles from './HeroBannerCarousel.module.css';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import PrimaryButton from '../Button/PrimaryButton';
import { useSelector } from 'react-redux';

// NOTE: project already loads slick CSS from public/index.html


const HeroBannerCarousel: React.FC = () => {
     const user = useSelector((state: any) => state.auth.user);
    const sliderRef = useRef<Slider>(null);
    const intl = useIntl();

const slides = [
    {
        id: 1,
        headlineId: 'hero.slide1.headline',
        headline: 'A Ty co dziś uszyjesz?',
        subtitleId: 'hero.slide1.subtitle',
        subtitle: 'Znajdź wykrój, który chodzi Ci po głowie',
        img: '/photos/bg-1.png',
        gradient: 'linear-gradient(to bottom, #d4b896, #ffffff)',
        target: "/patterns",
    },
    {
        id: 2,
        headlineId: 'hero.slide2.headline',
        headline: 'Szyjemy dobre wiadomości!',
        subtitleId: 'hero.slide2.subtitle',
        subtitle: 'Zapisz się do newslettera i otrzymuj inspiracje, nowości\noraz specjalne oferty od twórców',
        img: '/photos/bg-3.png',
        gradient: 'linear-gradient(to bottom, #c9b5a0, #ffffff)',
        target: "/newsletter-terms",
    },
    {
        id: 3,
        headlineId: 'hero.slide3.headline',
        headline: 'Sprzedawaj wykroje i rozwijaj swoją markę',
        subtitleId: 'hero.slide3.subtitle',
        subtitle: 'Skup się na projektowaniu, my zajmiemy się resztą',
        img: '/photos/bg-2.png',
        gradient: 'linear-gradient(to bottom, #9b7d8f, #ffffff)',
        target: user ? "/manage-pattern" : "/register",
    },
];

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
    };

    return (
        <div className={styles.wrapper}>
            <Slider ref={sliderRef} {...settings}>
                {slides.map((s) => (
                    <div key={s.id}>
                        <div
                            className={styles.slide}
                            style={{ background: s.gradient }}
                        >
                            <div className={styles.inner}>
                                {/* Text — left half */}
                                <Link to={s.target} className={styles.linkWrapper}>
                                    <div className={styles.textBlock}>
                                        <h1 className={styles.headline}>
                                            {intl.formatMessage({ id: s.headlineId, defaultMessage: s.headline })}
                                        </h1>
                                        <p className={styles.subtitle}>
                                            {intl.formatMessage({ id: s.subtitleId, defaultMessage: s.subtitle })}
                                        </p>
                                    </div>
                                    <PrimaryButton className={styles.learnMoreButton}>
                                        <FormattedMessage
                                            id="hero.learnMore" defaultMessage="Learn more..." />
                                    </PrimaryButton>
                                </Link>
                            </div>

                            {/* Image — pinned to right edge of slide */}
                            <div className={styles.imageBlock}>
                                <img
                                    src={s.img}
                                    alt={s.headline}
                                    className={styles.image}
                                />
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>

            {/* External navigation arrows */}
            <button
                aria-label={intl.formatMessage({ id: "hero.previousSlide", defaultMessage: "Previous slide" })}
                className={`${styles.arrowBtn} ${styles.prevBtn}`}
                onClick={() => sliderRef.current?.slickPrev()}
            >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="15 18 9 12 15 6" />
                </svg>
            </button>
            <button
                aria-label={intl.formatMessage({ id: "hero.nextSlide", defaultMessage: "Next slide" })}
                className={`${styles.arrowBtn} ${styles.nextBtn}`}
                onClick={() => sliderRef.current?.slickNext()}
            >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="9 18 15 12 9 6" />
                </svg>
            </button>
        </div>
    );
};

export default HeroBannerCarousel;
